import { Component, OnInit } from '@angular/core';
import { LocationsService } from '../services/locations/locations.service';
import {Router} from '@angular/router';

@Component({
  selector: 'rod-event-reservations',
  templateUrl: './event-reservations.component.html',
  styleUrls: ['./event-reservations.component.scss']
})
export class EventReservationsComponent implements OnInit {

  public reservationTypeChoosen: boolean = false;

  public fiestaActive = true;
  public fundraiserActive = false;

  public reservationSuccessIsActive: boolean = false;
  public locations;
  
  constructor(
    private _locationsService: LocationsService,
    private _router: Router
  ) { 

  }

  ngOnInit() {
    
  }

  public signUp(type) {
    if(typeof type === 'string') {
      this.reservationTypeChoosen = true;
      this._router.navigate(['/event-reservations', type]);
    }
    
  }

  public showFundraiser() {
    this.fiestaActive = false;
    this.fundraiserActive = true;
  }

  public showFiesta() {
    this.fundraiserActive = false;
    this.fiestaActive = true;
  }

  public closeReservationSuccess() {
    
  }

}



// WEBPACK FOOTER //
// ./src/app/event-reservations/event-reservations.component.ts